module.exports = __webpack_public_path__ + "img/a406c34653216db1176c0f8377de0f4.84dc8df7.jpg";